import { AreaDescriptionModel } from './areaDescription.model';

export class LandDescriptionModel {
    name: string;
    pk: number; 
    code: string;    
    status:number;
    areaDescriptionList:Array<AreaDescriptionModel>
  }